import { createSQLiteHTTPPool } from 'sqlite-wasm-http';
export class Db {
    static getColumn(row, columnName) {
        return row.row[row.columnNames.indexOf(columnName)];
    }
    constructor(pool) {
        this.pool = pool;
    }
    static async init(dbPath) {
        const pool = await createSQLiteHTTPPool({});
        pool.open(dbPath);
        return new Db(pool);
    }
    async exec(query, params) {
        console.debug(query, params);
        const result = this.pool.exec(query, params);
        console.debug(await result);
        return result;
    }
}
